// extracted by mini-css-extract-plugin
export default {"pageMain":"pageMain__SoTPF"};